import { render } from "./Q5-6-Meditate.vue?vue&type=template&id=ce8f6cf4&scoped=true"
import script from "./Q5-6-Meditate.vue?vue&type=script&lang=js"
export * from "./Q5-6-Meditate.vue?vue&type=script&lang=js"

import "./Q5-6-Meditate.vue?vue&type=style&index=0&id=ce8f6cf4&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce8f6cf4"]])

export default __exports__